import { createSelector } from 'reselect';

export const Types = {
  GET_REQUEST: 'vouchers/GET_REQUEST',
  GET_SUCCESS: 'vouchers/GET_SUCCESS',
  GET_FAILURE: 'vouchers/GET_FAILURE',

  GET_LIST_REQUEST: 'vouchers/GET_LIST_REQUEST',
  GET_LIST_SUCCESS: 'vouchers/GET_LIST_SUCCESS',
  GET_LIST_FAILURE: 'vouchers/GET_LIST_FAILURE',

  CREATE_REQUEST: 'vouchers/CREATE_REQUEST',
  CREATE_SUCCESS: 'vouchers/CREATE_SUCCESS',
  CREATE_FAILURE: 'vouchers/CREATE_FAILURE',

  UPDATE_REQUEST: 'vouchers/UPDATE_REQUEST',
  UPDATE_SUCCESS: 'vouchers/UPDATE_SUCCESS',
  UPDATE_FAILURE: 'vouchers/UPDATE_FAILURE',

  DELETE_REQUEST: 'vouchers/DELETE_REQUEST',
  DELETE_SUCCESS: 'vouchers/DELETE_SUCCESS',
  DELETE_FAILURE: 'vouchers/DELETE_FAILURE',

  GET_PLANS_REQUEST: 'vouchers/GET_PLANS_REQUEST',
  GET_PLANS_SUCCESS: 'vouchers/GET_PLANS_SUCCESS',
  GET_PLANS_FAILURE: 'vouchers/GET_PLANS_FAILURE',
};

const initialState = {
  data: [],
  loading: true,
  page: 1,
  totals: 1,

  detail: {
    data: {},
    loading: true,
  },

  create: {
    loading: false,
  },

  update: {
    loading: false,
  },

  delete: {
    loading: false,
  },

  plans: {
    data: [],
    loading: true,
  },
};

export default function vouchers(state = initialState, action) {
  switch (action.type) {
    case Types.GET_REQUEST:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
        },
      };
    case Types.GET_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload.voucher.data,
        },
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
        },
      };
    case Types.GET_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.vouchers.data,
        page: action.payload.vouchers.meta.current_page,
        totals: action.payload.vouchers.meta.total_pages,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case Types.CREATE_REQUEST:
      return {
        ...state,
        create: {
          ...state.create,
          loading: true,
        },
      };
    case Types.CREATE_SUCCESS:
    case Types.CREATE_FAILURE:
      return {
        ...state,
        create: {
          ...state.create,
          loading: false,
        },
      };
    case Types.UPDATE_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          loading: true,
        },
      };
    case Types.UPDATE_SUCCESS:
    case Types.UPDATE_FAILURE:
      return {
        ...state,
        update: {
          ...state.update,
          loading: false,
        },
      };
    case Types.GET_PLANS_REQUEST:
      return {
        ...state,
        plans: {
          ...state.plans,
          loading: true,
        },
      };
    case Types.GET_PLANS_SUCCESS:
      return {
        ...state,
        plans: {
          ...state.plans,
          data: action.payload.plans.data,
          loading: false,
        },
      };
    case Types.GET_PLANS_FAILURE:
      return {
        ...state,
        plans: {
          ...state.plans,
          loading: false,
        },
      };
    default:
      return state;
  }
}

export const Creators = {
  getVoucherRequest: id => ({
    type: Types.GET_REQUEST,
    payload: { id },
  }),

  getVoucherSuccess: voucher => ({
    type: Types.GET_SUCCESS,
    payload: { voucher },
  }),

  getVoucherFailure: () => ({
    type: Types.GET_FAILURE,
  }),

  getVouchersRequest: (page = 1) => ({
    type: Types.GET_LIST_REQUEST,
    payload: { page },
  }),

  getVouchersSuccess: vouchers => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { vouchers },
  }),

  getVouchersFailure: () => ({
    type: Types.GET_LIST_FAILURE,
  }),

  createVoucherRequest: data => ({
    type: Types.CREATE_REQUEST,
    payload: { data },
  }),

  createVoucherSuccess: () => ({
    type: Types.CREATE_SUCCESS,
  }),

  createVoucherFailure: () => ({
    type: Types.CREATE_FAILURE,
  }),

  updateVoucherRequest: (id, data) => ({
    type: Types.UPDATE_REQUEST,
    payload: { id, data },
  }),

  updateVoucherSuccess: () => ({
    type: Types.UPDATE_SUCCESS,
  }),

  updateVoucherFailure: () => ({
    type: Types.UPDATE_FAILURE,
  }),

  deleteVoucherRequest: id => ({
    type: Types.DELETE_REQUEST,
    payload: { id },
  }),

  deleteVoucherSuccess: () => ({
    type: Types.DELETE_SUCCESS,
  }),

  deleteVoucherFailure: () => ({
    type: Types.DELETE_FAILURE,
  }),

  getVouchersPlansRequest: () => ({
    type: Types.GET_PLANS_REQUEST,
  }),

  getVouchersPlansSuccess: plans => ({
    type: Types.GET_PLANS_SUCCESS,
    payload: { plans },
  }),

  getVouchersPlansFailure: () => ({
    type: Types.GET_PLANS_FAILURE,
  }),
};

export const Selectors = {
  plans: createSelector(
    state => state,
    plans => plans.map(local => ({ value: local.id, label: local.attributes.name })),
  ),

  detail: createSelector(
    state => state,
    voucher =>
    voucher.id && {
      ...voucher,
      attributes: {
        ...voucher.attributes,
        experience_plan_ids: voucher.attributes.plans.map(plan => ({ value: plan.id, label: plan.name })),
      },
    },
  )
};
